module.exports = __webpack_public_path__ + "static/media/linkedin.db9d5acd.svg";